const messages = {
  title: 'Good',
  waitingTitle: 'Congratulations! We\'re almost there',
  waitingPar1: 'Thank you for the effort on taking the impressions, photos and the medical history. The specialized orthodontists team will review them and design a customized treatment plan for you.',
  waitingPar2: 'We will send you your treatment plan for your approval in 6 to 8 days.',
  waitingPar3: 'The smile you\'ve always wanted is getting closer!',
}

export default messages
